/* eslint no-console: 0 */
/* eslint react-hooks/exhaustive-deps: 0 */
import { I18n } from 'aws-amplify'
import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useLoading } from '../../../../../presentation/contexts/loading'
import { useMe } from '../../../../../presentation/contexts/me'
import { usePage } from '../../../../../presentation/contexts/page'
import { formatDataForm, removeProperties } from '../../../../../presentation/helpers/helper-object'
import { removeSpaces, removeSpecialChars } from '../../../../../presentation/helpers/helper-string'
import UserEditor from '../../../../../presentation/pages/dashboard/configurations/user/editor'
import { theme } from '../../../../../presentation/styles/theme'
import { makeProfile } from '../../../../usecases/profiles/load-profile-factory'
import { makeStablishmentTables } from '../../../../usecases/stablishment-tables/load-stablishment-tables'
import { apiToForm, makeUsers } from '../../../../usecases/users/load-users'

const MakeUserEditor = () => {
  const { setHeader } = usePage()
  const { me } = useMe()
  const { onSetLoading } = useLoading()
  const history = useHistory()
  const location = useLocation()
  const [profiles, setProfiles] = useState([])
  const [tables, setTables] = useState([])
  const [errorMessage, setErrorMessage] = useState('')
  const [initialUser, setInitialUser] = useState<any | null>(null)
  const [formData, setFormData] = useState<any>(null)
  const [isToUpdate, setIsToUpdate] = useState<any>(null)

  const isCustomer = isToUpdate?.customer

  const getActiveTables = async (): Promise<any | undefined> => {
    try {
      if (!me) return null
      const stablishmentId = me.stablishments[0].id
      return await makeStablishmentTables(stablishmentId).load({ active: true })
    } catch (error) {
      return null
      // console.log(error)
    }
  }

  useEffect(() => {
    const controller = new AbortController();
    (async () => {
      const { item } = location.state as any

      onSetLoading(true)
      setHeader({
        title: item ? 'Editar Usuário' : 'Novo Usuário',
        goTo: '/dashboard/users',
      })

      try {
        if (!me) return
        const stablishmentId = me.stablishments[0].id
        const response = await makeProfile(stablishmentId).load()
        const formattedProfiles = response.profiles.map((profile: any) => ({
          label: profile.name,
          value: JSON.stringify(profile),
        }))
        const { stablishmentTables } = await getActiveTables()
        if (stablishmentTables) {
          const formattedTables = stablishmentTables.map((table: any) => ({
            label: table.name,
            value: JSON.stringify(table.id),
          }))
          setTables(formattedTables)
        }

        if (item) {
          const data = apiToForm(item)

          setInitialUser(data)
          setIsToUpdate(item)
        }

        setProfiles(formattedProfiles)
      } catch (error) {
        console.log(error)
      } finally {
        onSetLoading(false)
      }
    })()

    return () => controller?.abort()
  }, [me])

  const documentTypeMapper = {
    0: 'CPF',
    1: 'CNPJ',
  }
  const documentType = initialUser && initialUser.documentType
    ? documentTypeMapper[(initialUser.documentType as 0 | 1)]
    : 'CPF'

  const dataForm = [
    {
      items: [
        {
          title: 'Dados do usuário',
          subtitle: '',
          component: 'Title',
        },
        {
          component: 'InputGroup',
          inputs: [
            {
              component: 'Input',
              mask: 'CNPJ',
              name: 'document',
              label: documentType,
              title: documentType,
              value: '',
              disabled: !!isCustomer,
              placeholder: 'Digite aqui',
              // validations: 'inputRequired',
            },
            {
              component: 'Input',
              name: 'fullname',
              label: 'Nome completo',
              title: 'Nome completo',
              value: '',
              disabled: !!isCustomer,
              required: true,
              placeholder: 'Digite aqui',
              validations: 'inputRequired',
            },
            {
              component: 'InputPhone',
              mask: 'PHONE_NUMBER',
              name: 'phoneNumber',
              disabled: !!isCustomer,
              label: 'Telefone',
              title: 'Telefone',
              value: '',
              placeholder: 'Digite aqui',
              // validations: 'inputRequired',
            },
          ],
        },
        {
          name: 'email',
          component: 'Input',
          value: '',
          disabled: !!isCustomer,
          type: 'e-mail',
          placeholder: 'Digite aqui',
          title: 'E-mail',
          label: 'E-mail',
          required: true,
          validations: 'emailRequired',
          styleContainer: { width: '32%', marginBottom: '30px' },
        },
        {
          title: 'Tipo de Acesso',
          subtitle: '',
          component: 'Title',
        },
        {
          name: 'profiles',
          component: 'InputCheck',
          value: [],
          title: '',
          disabled: !!isCustomer,
          label: '',
          required: true,
          options: profiles,
          validations: 'arrayRequired',
        },
        {
          component: 'InputGroup',
          inputs: [
            {
              name: 'hasAllTables',
              component: 'InputRadio',
              value: '',
              title: 'Associar todas as mesas?',
              disabled: !!isCustomer,
              label: 'Associar todas as mesas?',
              // required: true,
              styleContainer: { width: '20%' },
              options: [
                { label: 'Sim', value: 'true' },
                { label: 'Não', value: 'false' },
              ],
              dependencies: [{ name: 'profiles', value: ['Garçom'] }],
              // validations: 'inputRadioRequired',
            },
            {
              name: 'stablishmentTables',
              component: 'SelectChecklist',
              value: [],
              title: 'Mesas Associadas',
              label: 'Mesas Associadas',
              required: true,
              options: tables,
              disabled: !!isCustomer,
              placeholder: 'associar mesa(s) ao garçom',
              validations: 'arrayRequired',
              styleContainer: { width: '32%' },
              dependencies: [{ name: 'hasAllTables', value: 'false' }],
            },
          ],
        },
        {
          title: 'Acessos do usuário',
          subtitle: '',
          component: 'Title',
        },
        {
          component: 'InputGroup',
          inputs: [
            {
              component: 'Input',
              value: '',
              name: 'username',
              label: 'E-mail',
              title: 'E-mail',
              type: 'e-mail',
              disabled: !!isCustomer,
              placeholder: 'Digite aqui',
              required: true,
              validations: 'emailRequired',
              mirroredValue: 'email',
            },
            {
              component: 'Input',
              name: 'password',
              label: 'Senha (Somente números - 6 dígitos)',
              title: 'Senha (Somente números - 6 dígitos)',
              required: !isToUpdate,
              type: 'number',
              disabled: !!isCustomer,
              value: '',
              max: 6,
              placeholder: 'Digite aqui',
              validations: 'passwordRequired',
            },
          ],
          style: { width: '66%' },
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Salvar',
          canShow: !isCustomer,
          submittingText: 'Salvando...',
          style: { background: theme.colors.blue, width: '187px', marginTop: '45px' },
        },
      ],
    },
  ]

  const onSubmit = async (values:any): Promise<void> => {
    let itemToSubmit = { ...values }

    const formatProfiles = (value: any) => value.map((v: any) => JSON.parse(v))
    const formatTables = (value: any) => value.map((table: any) => ({ id: Number(table) }))
    const formatPhoneNumber = (value: any) => {
      if (!value) return null
      return Number(removeSpaces(removeSpecialChars(value)))
    }

    const itemGroup = [
      { name: 'cpf', adapter: removeSpecialChars },
      { name: 'username' },
      { name: 'password' },
      { name: 'email' },
      { name: 'fullname' },
      { name: 'phoneNumber', adapter: formatPhoneNumber },
      { name: 'profiles', adapter: formatProfiles },
      { name: 'stablishmentTables', adapter: formatTables },
      { name: 'hasAllTables' },
    ]
    itemToSubmit = formatDataForm(itemToSubmit, itemGroup)

    if (itemToSubmit.hasAllTables) {
      itemToSubmit.stablishmentTables = []
    }

    const itemsToDelete = ['button', 'undefined']
    if (!itemToSubmit.username) itemsToDelete.push('username')
    if (itemToSubmit.phoneNumber === 0 || itemToSubmit.phoneNumber === '0') itemToSubmit.phoneNumber = null
    if (itemToSubmit.hasAllTables === null || itemToSubmit.hasAllTables === '') itemsToDelete.push('hasAllTables')
    itemToSubmit = removeProperties(itemToSubmit, itemsToDelete)

    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      if (isToUpdate) {
        await makeUsers(stablishmentId).patch(isToUpdate.id, itemToSubmit)
      } else {
        await makeUsers(stablishmentId).post(itemToSubmit)
      }
      history.push('/dashboard/users')
    } catch (error: any) {
      const msg = I18n.get(error.name) as string
      console.log(msg)
      setErrorMessage(msg)
    }
  }

  return (
    <UserEditor
      setData={setFormData}
      data={formData}
      dataForm={dataForm}
      onSubmit={onSubmit}
      initialData={initialUser}
      errorMessage={errorMessage}
    />
  )
}

export default MakeUserEditor
